module.exports = __webpack_public_path__ + "assets/img/de-8d1fc3d9.png";